export default {
    setAuth (state, payload) {
        state.auth = payload
    },
    setRefererRouteLogin (state, payload) {
        state.refererRouteLogin = payload
    },
    setUserLoggedIn (state, payload) {
        localStorage.setItem('ytauth-user', payload)
        state.userLoggedIn = payload
    },
    setRunRefreshToken (state, payload) {
        state.runRefreshToken = payload
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js